import React, { Component } from "react";
import {Link} from "react-router-dom";

import pd_thumb_2 from "../../../assets/images/perubike_images/centro_andes_1.JPG"
import pd_thumb_2_1 from "../../../assets/images/perubike_images/centrol_andes_3.JPG"
import pd_thumb_4 from "../../../assets/images/perubike_images/centro_andes_2_1.JPG"
import pd_thumb_5 from "../../../assets/images/perubike_images/centro_andes_2_3.JPG"
import pd_thumb_6 from "../../../assets/images/perubike_images/centro_andes_2_4.JPG"
import pd_thumb_7 from "../../../assets/images/perubike_images/centro_andes_2_5.JPG"
import pd_thumb_8 from "../../../assets/images/perubike_images/centro_andes_2_6.JPG"
import pd_thumb_9 from "../../../assets/images/perubike_images/centro_andes_2_7.JPG"
import pd_thumb_10 from "../../../assets/images/perubike_images/centro_andes_2_8.JPG"
import pd_thumb_11 from "../../../assets/images/perubike_images/centro_andes_2_9.JPG"
import pd_thumb_12 from "../../../assets/images/perubike_images/centro_andes_2_10.JPG"

import pm_sm_1  from "../../../assets/images/banners/banner_lima_bohemian.JPG";
import pm_sm_4  from "../../../assets/images/banners/banner_lima_bahia.jpg";
import pm_sm_2  from "../../../assets/images/banners/banner_pachacamac.JPG";
import pm_sm_3  from "../../../assets/images/banners/banner_centro_historico.JPG";


// Banners de packages
import centro_historico_1  from "../../../assets/images/banners/banner_centro_historico.JPG";
import andes_a_la_selva_1 from "../../../assets/images/perubike_images/de los andes a la selva/banner_1.JPG"
import central_andes_1_1 from "../../../assets/images/perubike_images/centro_andes_1.JPG"
import central_andes_2_1 from "../../../assets/images/perubike_images/central_andes_2/banner_1.JPG";

import andes_a_la_costa_1 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_1.JPG";
import andes_a_la_costa_2 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_2.JPG";
import andes_a_la_costa_3 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_3.JPG";
import andes_a_la_costa_4 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_4.JPG";  
import andes_a_la_costa_5 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_5.JPG";  
import andes_a_la_costa_6 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_6.JPG";
import andes_a_la_costa_7 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_7.JPG";
import andes_a_la_costa_8 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_8.JPG";
import andes_a_la_costa_9 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_9.JPG";
import andes_a_la_costa_10 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_10.JPG";
import andes_a_la_costa_11 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_11.JPG";
import andes_a_la_costa_12 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_12.JPG";
import andes_a_la_costa_13 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_13.JPG";
import andes_a_la_costa_14 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_14.JPG";
import andes_a_la_costa_15 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_15.JPG";
import andes_a_la_costa_16 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_16.JPG";
import andes_a_la_costa_17 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_17.JPG";
import andes_a_la_costa_18 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_18.JPG";
import andes_a_la_costa_19 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_19.JPG";
import andes_a_la_costa_20 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_20.JPG";
import andes_a_la_costa_21 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_21.jpg";
import andes_a_la_costa_22 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_22.jpg";
import andes_a_la_costa_23 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_23.jpg";
import andes_a_la_costa_24 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_24.jpg";
import andes_a_la_costa_25 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_25.JPG";
import andes_a_la_costa_26 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_26.jpg";
import andes_a_la_costa_27 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_27.JPG";
import andes_a_la_costa_28 from "../../../assets/images/perubike_images/de_los_andes_a_la_costa/andes_a_la_costa_28.jpg";

import { SRLWrapper } from "simple-react-lightbox";

import "react-datepicker/dist/react-datepicker.css";

import "../../../i18n";
import { useTranslation } from "react-i18next";


function withHooks(WrappedComponent) {
    return function(props) {
      const {t} = useTranslation();
      return (
        < WrappedComponent t={t} {...props} />
      );
    };
  }

class AndesALaCosta extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:new Date(),
        };
    }
    changeDatepickerHandeller=(date)=>{
        this.setState({ startDate: date });
    }

    componentDidMount(){
        this.scrollTop();
    }

    scrollTop()
    {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
  render() {
    const startDate =this.state.startDate;

    const {t} = this.props;

    return (
        <>
            {/* ===============  breadcrumb area start =============== */}
            <div className="breadcrumb-area-andes-a-la-costa ">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="breadcrumb-wrap">
                                <h2>{t("centro_historico_1")}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ===============  breadcrumb area end =============== */}
            <div className="package-details-wrapper pt-120">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="package-details">
                                <div className="package-thumb">
                                    <img src={andes_a_la_costa_13} alt="" />
                                </div>
                                <div className="package-header">
                                    <div className="package-title">
                                        <h3>{t("andes_a_la_costa_1")}</h3>
                                        {/* <h4>Sundays Only</h4> */}
                                        <h4>{t("centro_historico_3")}</h4>
                                        {/* <strong><i className="flaticon-arrival" />
                                            Mount Dtna, Spain
                                        </strong> */}
                                    </div>
                                    {/* <div className="pd-review">
                                        <p>Excellent</p>
                                        <ul>
                                            <li><i className="bx bxs-star" /></li>
                                            <li><i className="bx bxs-star" /></li>
                                            <li><i className="bx bxs-star" /></li>
                                            <li><i className="bx bxs-star" /></li>
                                            <li><i className="bx bx-star" /></li>
                                        </ul>
                                        <p>800 Review</p>
                                    </div> */}
                                </div>
                                <div className="package-tab">
                                    <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true"><i className="flaticon-info" />
                                                {t("information")}</button>
                                        </li>
                                        {/* <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false"><i className="flaticon-clipboard" />
                                                Travel Plan</button>
                                        </li> */}
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false"> <i className="flaticon-gallery" />
                                                {t("our_gallary")}</button>
                                        </li>
                                    </ul>
                                    <div className="tab-content p-tab-content" id="pills-tabContent">
                                        <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="tab-content-1">
                                                        <div className="p-overview">
                                                            <h5>{t("centro_historico_3")}</h5>
                                                            <p>{t("andes_a_la_costa_3")}</p>
                                                            <p>{t("andes_a_la_costa_4")}</p>
                                                            <p>{t("andes_a_la_costa_5")}</p>
                                                            <p>{t("andes_a_la_costa_6")}</p>
                                                        </div>
                                                        <br/>
                                                        <div className="p-overview">
                                                            <h5 style={{"margin":"0px"}}>{t("andes_a_la_costa_15")}</h5>
                                                            <p>{t("andes_a_la_costa_16")}</p> 
                                                            <p>{t("andes_a_la_costa_17")}</p>
                                                        </div>
                                                        <br/>
                                                        <div className="p-overview">
                                                            <h5 style={{"margin":"0px"}}>{t("andes_a_la_costa_18")}</h5>
                                                            <p>{t("andes_a_la_costa_19")}</p> 
                                                            <p>{t("andes_a_la_costa_20")}</p>
                                                        </div>
                                                        <br/>
                                                        <div className="p-overview">
                                                            <h5 style={{"margin":"0px"}}>{t("andes_a_la_costa_21")}</h5>
                                                            <p>{t("andes_a_la_costa_22")}</p>
                                                        </div>
                                                        <br/>
                                                        <div className="p-overview">
                                                            <h5 style={{"margin":"0px"}}>{t("andes_a_la_costa_23")}</h5>
                                                            <p>{t("andes_a_la_costa_24")}</p> 
                                                            <p>{t("andes_a_la_costa_25")}</p>
                                                        </div>
                                                        <br/>
                                                        <div className="package-thumb">
                                                            <img src={andes_a_la_costa_21} alt="" />
                                                        </div>
                                                        <br/>
                                                        {/* <p>{t("centro_historico_9")}</p>
                                                        <p>
                                                            <b>{t("centro_historico_10")}</b> 
                                                            {t("centro_historico_10.1")}
                                                        </p> */}
                                                        <div className="p-details-table">
                                                            <table className="table caption-top">
                                                                <tbody>
                                                                <tr>
                                                                    <td>{t("central_andes_30")}</td>
                                                                    <td>{t("andes_a_la_costa_31")}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{t("andes_a_la_costa_31_1")}</td>
                                                                    <td>{t("central_andes_33_1")}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{t("central_andes_3")}</td>
                                                                    <td>{t("central_andes_4")}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{t("central_andes_5")}</td>
                                                                    <td>{t("central_andes_6")}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{t("central_andes_7")}</td>
                                                                    <td>{t("central_andes_8")}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{t("central_andes_11")}</td>
                                                                    <td>{t("central_andes_12")}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{t("central_andes_13")}</td>
                                                                    <td>{t("central_andes_14")}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{t("central_andes_37")}</td>
                                                                    <td>
                                                                        <ul className="table-list-allow">
                                                                            <li><i className="bx bx-check" />{t("central_andes_38")}</li>
                                                                            <li><i className="bx bx-check" />{t("central_andes_39")}</li>
                                                                            <li><i className="bx bx-check" />{t("central_andes_40")}</li>
                                                                            <li><i className="bx bx-check" />{t("central_andes_41")}</li>
                                                                            <li><i className="bx bx-check" />{t("central_andes_42")}</li>
                                                                            <li><i className="bx bx-check" />{t("central_andes_43")}</li>
                                                                            <li><i className="bx bx-check" />{t("central_andes_44")}</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{t("central_andes_45")}</td>
                                                                    <td>
                                                                        <ul className="table-list-allow">
                                                                            <li><i className="bx bx-x" /> {t("central_andes_46")}</li>
                                                                            <li> <i className="bx bx-x" /> {t("central_andes_47")}</li>
                                                                            <li><i className="bx bx-x" /> {t("central_andes_48")}</li>
                                                                            <li><i className="bx bx-x" /> {t("central_andes_49")}</li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{t("central_andes_50")}</td>
                                                                    <td>{t("central_andes_51")}</td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                                            <div className="tab-contant-3">
                                                <SRLWrapper>
                                                <div className="row">
                                                    <div className="col-lg-8 col-md-8">
                                                        <div className="package-grid-one">
                                                            <div className="single-grid">
                                                                <Link to={andes_a_la_costa_1} className="g-img-md-2 main-gallary">
                                                                    <img src={andes_a_la_costa_1} alt="gallary-img" />
                                                                </Link>

                                                                <Link to={andes_a_la_costa_2} className="g-img-sm-2-2 main-gallary">
                                                                    <img src={andes_a_la_costa_2} alt="gallary-img" />
                                                                </Link>

                                                                <Link to={andes_a_la_costa_3} className="g-img-sm-2-2 main-gallary">
                                                                    <img src={andes_a_la_costa_3} alt="gallary-img" />
                                                                </Link>
                                                                <Link to={andes_a_la_costa_4} className="g-img-sm-2-2 main-gallary">
                                                                    <img src={andes_a_la_costa_4} alt="gallary-img" />
                                                                </Link>
                                                            </div>
                                                            <div className="single-grid mt-24">
                                                            <Link to={andes_a_la_costa_5} className="g-img-md-2 main-gallary">
                                                                    <img src={andes_a_la_costa_5} alt="gallary-img" />
                                                                </Link>

                                                                <Link to={andes_a_la_costa_6} className="g-img-sm-2-2 main-gallary">
                                                                    <img src={andes_a_la_costa_6} alt="gallary-img" />
                                                                </Link>

                                                                <Link to={andes_a_la_costa_7} className="g-img-sm-2-2 main-gallary">
                                                                    <img src={andes_a_la_costa_7} alt="gallary-img" />
                                                                </Link>
                                                                <Link to={andes_a_la_costa_8} className="g-img-sm-2-2 main-gallary">
                                                                    <img src={andes_a_la_costa_8} alt="gallary-img" />
                                                                </Link>
                                                            </div>

                                                            <div className="single-grid mt-24">
                                                                <Link to={andes_a_la_costa_9} className="g-img-md-2 main-gallary">
                                                                    <img src={andes_a_la_costa_9} alt="gallary-img" />
                                                                </Link>

                                                                <Link to={andes_a_la_costa_10} className="g-img-sm-2-2 main-gallary">
                                                                    <img src={andes_a_la_costa_10} alt="gallary-img" />
                                                                </Link>

                                                                <Link to={andes_a_la_costa_11} className="g-img-sm-2-2 main-gallary">
                                                                    <img src={andes_a_la_costa_11} alt="gallary-img" />
                                                                </Link>
                                                                <Link to={andes_a_la_costa_12} className="g-img-sm-2-2 main-gallary">
                                                                    <img src={andes_a_la_costa_12} alt="gallary-img" />
                                                                </Link>
                                                            </div>

                                                            <div className="single-grid mt-24">
                                                                <Link to={andes_a_la_costa_13} className="g-img-md-2 main-gallary">
                                                                    <img src={andes_a_la_costa_14} alt="gallary-img" />
                                                                </Link>

                                                                <Link to={andes_a_la_costa_15} className="g-img-sm-2-2 main-gallary">
                                                                    <img src={andes_a_la_costa_15} alt="gallary-img" />
                                                                </Link>

                                                                <Link to={andes_a_la_costa_16} className="g-img-sm-2-2 main-gallary">
                                                                    <img src={andes_a_la_costa_16} alt="gallary-img" />
                                                                </Link>
                                                                <Link to={andes_a_la_costa_17} className="g-img-sm-2-2 main-gallary">
                                                                    <img src={andes_a_la_costa_17} alt="gallary-img" />
                                                                </Link>
                                                            </div>

                                                            <div className="single-grid mt-24">
                                                                <Link to={andes_a_la_costa_18} className="g-img-md-2 main-gallary">
                                                                    <img src={andes_a_la_costa_18} alt="gallary-img" />
                                                                </Link>

                                                                <Link to={andes_a_la_costa_19} className="g-img-sm-2-2 main-gallary">
                                                                    <img src={andes_a_la_costa_19} alt="gallary-img" />
                                                                </Link>

                                                                <Link to={andes_a_la_costa_20} className="g-img-sm-2-2 main-gallary">
                                                                    <img src={andes_a_la_costa_20} alt="gallary-img" />
                                                                </Link>
                                                                <Link to={andes_a_la_costa_21} className="g-img-sm-2-2 main-gallary">
                                                                    <img src={andes_a_la_costa_21} alt="gallary-img" />
                                                                </Link>
                                                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-4">
                                                        <div className="package-grid-two">
                                                            <div className="single-grid-3">
                                                                <Link to={andes_a_la_costa_22}  className="main-gallary">
                                                                    <img src={andes_a_la_costa_22} alt="gallary-img" />
                                                                </Link>
                                                            </div>
                                                            <div className="single-grid-3 mt-24">
                                                                <Link to={andes_a_la_costa_23}  className="single-grid-2 main-gallary mt-30">
                                                                    <img src={andes_a_la_costa_23} alt="gallary-img" />
                                                                </Link>
                                                            </div>
                                                            <div className="single-grid-3 mt-24">
                                                                <Link to={andes_a_la_costa_24}  className="main-gallary mt-30">
                                                                    <img src={andes_a_la_costa_24} alt="gallary-img" />
                                                                </Link>
                                                            </div>
                                                            <div className="single-grid-3 mt-24">
                                                                <Link to={andes_a_la_costa_25}  className="main-gallary mt-30">
                                                                    <img src={andes_a_la_costa_25} alt="gallary-img" />
                                                                </Link>
                                                            </div>
                                                            <div className="single-grid-3 mt-24">
                                                                <Link to={andes_a_la_costa_26}  className="main-gallary mt-30">
                                                                    <img src={andes_a_la_costa_26} alt="gallary-img" />
                                                                </Link>
                                                            </div>                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                </SRLWrapper>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="package-d-sidebar">
                                <div className="row">
                                    <div className="col-lg-12 col-md-6">
                                        <div className="p-sidebar-form">
                                            <form>
                                                <h5 className="package-d-head">{t("book_this_package")}</h5>
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <input type="submit" name={t("book_now")} value={t("book_now")} />
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-6">
                                        <div className="p-sidebar-cards mt-40">
                                            <h5 className="package-d-head">{t("popular_packages")}</h5>
                                            <ul className="package-cards">
                                                <li className="package-card-sm">
                                                    <div className="p-sm-img">
                                                        <img src={pm_sm_4} alt="" />
                                                    </div>
                                                    <div className="package-info">
                                                        <h3><i className="flaticon-arrival" />
                                                            <Link to={`${process.env.PUBLIC_URL}/lima_bahia`}>{t("lima_bohemian_45")}</Link>
                                                        </h3>
                                                        <h5><span>$95</span>/ {t("per_person")}</h5>
                                                    </div>
                                                </li>
                                                <li className="package-card-sm">
                                                    <div className="p-sm-img">
                                                        <img src={pm_sm_1} alt="" />
                                                    </div>
                                                    <div className="package-info">
                                                        <h3><i className="flaticon-arrival" />
                                                            <Link to={`${process.env.PUBLIC_URL}/lima_bohemian`}>{t("pachacamac_56")}</Link>
                                                        </h3>
                                                        <h5><span>$95</span>/ {t("per_person")}</h5>
                                                    </div>
                                                </li>
                                                <li className="package-card-sm">
                                                    <div className="p-sm-img">
                                                        <img src={pm_sm_2} alt="" />
                                                    </div>
                                                    <div className="package-info">
                                                        <h3><i className="flaticon-arrival" />
                                                            <Link to={`${process.env.PUBLIC_URL}/pachacamac`}>Pachacamac</Link>
                                                        </h3>
                                                        <h5><span>$95</span>/ {t("per_person")}</h5>
                                                    </div>
                                                </li>
                                                <li className="package-card-sm">
                                                    <div className="p-sm-img">
                                                        <img src={centro_historico_1} alt="" />
                                                    </div>
                                                    <div className="package-info">
                                                        <h3><i className="flaticon-arrival" />
                                                            <Link to={`${process.env.PUBLIC_URL}/centro_historico`}>{t("lima_bohemian_51")}</Link>
                                                        </h3>
                                                        <h5><span>$95</span>/ {t("per_person")}</h5>
                                                    </div>
                                                </li>
                                                <li className="package-card-sm">
                                                    <div className="p-sm-img">
                                                        <img src={central_andes_1_1} alt="" />
                                                    </div>
                                                    <div className="package-info">
                                                        <h3><i className="flaticon-arrival" />
                                                            <Link to={`${process.env.PUBLIC_URL}/central_andes`}>{t("central_andes_1")}</Link>
                                                        </h3>
                                                        <h5><span>$760</span>/ {t("per_person")}</h5>
                                                    </div>
                                                </li>
                                                <li className="package-card-sm">
                                                    <div className="p-sm-img">
                                                        <img src={central_andes_2_1} alt="" />
                                                    </div>
                                                    <div className="package-info">
                                                        <h3><i className="flaticon-arrival" />
                                                            <Link to={`${process.env.PUBLIC_URL}/central_andes_2`}>{t("central_andes_2_1")}</Link>
                                                        </h3>
                                                        <h5><span>$760</span>/ {t("per_person")}</h5>
                                                    </div>
                                                </li>
                                                <li className="package-card-sm">
                                                    <div className="p-sm-img">
                                                        <img src={andes_a_la_selva_1} alt="" />
                                                    </div>
                                                    <div className="package-info">
                                                        <h3><i className="flaticon-arrival" />
                                                            <Link to={`${process.env.PUBLIC_URL}/andes_a_la_selva`}>{t("andes_a_la_selva_1")}</Link>
                                                        </h3>
                                                        <h5><span>$870</span>/ {t("per_person")}</h5>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
  }
}

// export default CentroHistorico;
export default withHooks(AndesALaCosta);
